type getLocalStorageTypes = 'user' | 'token'

/**
 * Retrieves data from the browser's localStorage based on the specified type.
 * @param type The key in localStorage to fetch.
 * @returns The parsed object if the key is 'user', otherwise the raw string value from localStorage.
 */
export const getLocalStorage = (type: getLocalStorageTypes) => {
  switch (type) {
    case 'user':
      return JSON.parse(localStorage.getItem('user')!)

    default:
      return localStorage.getItem(type)
  }
}
